import React from 'react'
import './index.css'

import Image from './Image'
import Links from './Links'
import { Card } from '../Card'

export function Profile({}) {
  return (
    <div className="srh-profile">
      <Image />
      <h1 className="srh-name">Z<span>HEKUN</span> Z<span>HANG</span></h1>
      <p className="srh-aboutme">
        Full-time software programmer, math lover, <br/>chess amateur
      </p>
      <Card 
        name="uni"
        //title=""
        role={<>Senior student in Mathematics & Computer Science <br/> @ University of Illinois at Urbana-Champaign</>}
        description="Fall 2016 - Dec 2019"
      />
      <Links />
    </div>
  )
}